module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    ref: "code"
  }, [_c('code', [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4aa11e5a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/docs/CodeBlock.vue
// module id = 291
// module chunks = 2